import React from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody,
  Button, FormControl, FormLabel, Input, Flex, Text, Alert, AlertIcon, Textarea,
} from '@chakra-ui/react';
import * as FiIcons from 'react-icons/fi';
import { createService } from '../../../../../store/services/servicesSlice';
import theme from '../../../../global/theme';

const CreateModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const services = useSelector(state => state.services);
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: { order: 0, icon_color: '#60a5fa' }
  });

  const onSubmit = (values) => {
    const tagsArray = values.tags_input
      ? values.tags_input.split(',').map(t => t.trim()).filter(Boolean)
      : [];
    dispatch(createService({
      ...values,
      tags: JSON.stringify(tagsArray),
    })).unwrap().then(() => onClose());
  };

  return (
    <Modal isOpen onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent borderRadius={4} paddingBlock={4} bg={theme.dark}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader textAlign="center" color="orange" fontSize={20}>إضافة خدمة</ModalHeader>
          <ModalBody>
            {services.errors.length > 0 && (
              <Alert status="error" variant="left-accent" marginBottom={4}>
                <AlertIcon />
                {services.errors.map((e, i) => <Text key={i}>{e?.msg}</Text>)}
              </Alert>
            )}
            <FormControl mb={4}>
              <FormLabel color={theme.light}>عنوان الخدمة *</FormLabel>
              <Input bg={theme.light} border="none" borderRadius={4}
                {...register('title', { required: 'مطلوب' })} />
              {errors.title && <Text color="red.400" mt={1}>{errors.title.message}</Text>}
            </FormControl>
            <FormControl mb={4}>
              <FormLabel color={theme.light}>الوصف</FormLabel>
              <Textarea bg={theme.light} border="none" borderRadius={4} rows={4} {...register('description')} />
            </FormControl>
            <FormControl mb={4}>
              <FormLabel color={theme.light}>الوسوم (مفصولة بفاصلة)</FormLabel>
              <Input bg={theme.light} border="none" borderRadius={4}
                placeholder="React, Node.js, API" {...register('tags_input')} />
            </FormControl>
            <Flex gap={4} mb={4}>
              <FormControl>
                <FormLabel color={theme.light}>اسم الأيقونة</FormLabel>
                <Input bg={theme.light} border="none" borderRadius={4}
                  placeholder="FiPackage" {...register('icon_name')} />
              </FormControl>
              <FormControl>
                <FormLabel color={theme.light}>لون الأيقونة</FormLabel>
                <Input type="color" bg={theme.light} border="none" borderRadius={4} {...register('icon_color')} />
              </FormControl>
              <FormControl>
                <FormLabel color={theme.light}>الترتيب</FormLabel>
                <Input type="number" bg={theme.light} border="none" borderRadius={4} {...register('order')} />
              </FormControl>
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Flex justifyContent="flex-end" gap={3}>
              <Button type="submit" rightIcon={<FiIcons.FiSave />} colorScheme="green"
                isLoading={services.isLoading}>حفظ</Button>
              <Button type="button" rightIcon={<FiIcons.FiX />} colorScheme="red"
                isLoading={services.isLoading} onClick={onClose}>إلغاء</Button>
            </Flex>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default CreateModal;
